import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import AabIcon from '@aab/sc-aab-icon/src/AabIcon';
import { n200, g300, white } from '@aab/sc-styles-colors';
import Styles from './styles.scss';

export default class AabAction extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    // Initialize LitElement properties here
    this.label = '';
    this.icon = '';
    this.disabled = false;
  }

  static get properties() {
    return {
      label: { type: String },
      icon: { type: String },
      disabled: { type: Boolean },
      inverted: { type: Boolean },
    };
  }

  static get scopedElements() {
    return {
      'aab-icon': AabIcon,
    };
  }

  static get styles() {
    return [Styles];
  }

  /**
   * Color for the icon based on state of the element
   * @method getIconColor
   * @return {String} - Returns the color for the icon
   */
  getIconColor() {
    if (this.disabled) { return n200; }
    if (this.inverted) { return white; }
    // default;
    return g300;
  }

  render() {
    return html`
      <button type="button" ?disabled=${this.disabled} class="d-flex p-0 overflow-hide link text-left ${this.inverted ? 'inverted' : ''}">
        ${this.icon ? html`<aab-icon size="3" class="mr-1" color=${this.getIconColor()} svg="${this.icon}"></aab-icon>` : html``}
        ${this.label}
      </button>
    `;
  }
}
